/** @file Closes a sink: bumps versions of the chunks it filled and returns how many it used. */
import type { Sink } from './createSink';

/**
 * Bumps `version` and `topologyVersion` of every used chunk on every call, identical content included (W2-22:
 * the renderer's dirty skip compares identity + version); empty bounds become zeros. Returns `sink.used`.
 */
export function finishSink(sink: Sink): number {
  for (let i = 0; i < sink.used; i++) {
    const chunk = sink.out[i];
    if (chunk === undefined) continue;
    chunk.version += 1;
    chunk.topologyVersion += 1;
    if (chunk.vertexCount === 0) chunk.bounds.fill(0);
  }
  return sink.used;
}
